'use client';

import React from 'react';
import { Avatar, Badge, Button } from '@heroui/react';
import { Icon } from '@iconify/react';
import { cn } from '@heroui/react';
import CustomHeroButton from '../button';
import Typography from '../typography/Typography';
import { useTranslations } from '../../contexts/translation.context';

export type NotificationType = 'default';

export type NotificationItem = {
  id: string;
  isRead?: boolean;
  avatar: string;
  description: string;
  name: string;
  time: string;
  type?: NotificationType;
  onMarkAsRead?: () => void;
};

export type NotificationItemProps = React.HTMLAttributes<HTMLDivElement> & NotificationItem;

const NotificationItem = React.forwardRef<HTMLDivElement, NotificationItemProps>(
  (
    { children, avatar, name, description, type, time, isRead, className, onMarkAsRead, ...props },
    ref
  ) => {
    const { t } = useTranslations();
    /**
     * Defines the content for different types of notifications.
     */
    const contentByType: Record<NotificationType, React.ReactNode> = {
      default: null,
      // file: (
      //   <div className="flex items-center gap-2">
      //     <Icon className="text-secondary" icon="solar:figma-file-linear" width={30} aria-label="Файл Figma" />
      //     <div className="flex flex-col">
      //       <strong className="text-small font-medium">Brand_Logo_v1.2.fig</strong>
      //       <p className="text-tiny text-default-400">3.4 MB</p>
      //     </div>
      //   </div>
      // ),
    };

    return (
      <div
        ref={ref}
        className={cn(
          'flex gap-3 border-b border-divider p-4',
          {
            'bg-primary-50/50': !isRead,
          },
          className
        )}
        {...props}
      >
        <div className="flex flex-col gap-1">
          <Typography className="word-break-all max-w-[25rem]" variant="body2">
            {description || children}
          </Typography>
          <time className="text-neutral-500 text-xs leading-4 font-regular">{time}</time>
          {/* {type && contentByType[type]} */}
          {!isRead && (
            <div>
              <CustomHeroButton
                title={t('notificationsCard.markAsReadButton')}
                className="bg-[#E6F1FE] text-partner mt-2"
                onPress={onMarkAsRead}
                // isLoading={isSubmittingStep3}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
);

NotificationItem.displayName = 'NotificationItem';

export default NotificationItem;
